<template>
    <a :href="link" target="_blank" rel="noopener noreferrer">
      <slot></slot> <!-- Slot to pass content -->
    </a>
  </template>
  
  <script>
  export default {
    name: "ExternalLink",
    props: {
      link: {
        type: String,
        required: true
      }
    }
  }
  </script>  